/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_mobile_analytics_app_id": "8edfddcf25d4476ca99834e56cf7a71e",
    "aws_mobile_analytics_app_region": "ap-northeast-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "8edfddcf25d4476ca99834e56cf7a71e",
            "region": "ap-northeast-1"
        }
    },
    "Notifications": {
        "InAppMessaging": {
            "AWSPinpoint": {
                "appId": "8edfddcf25d4476ca99834e56cf7a71e",
                "region": "ap-northeast-1"
            }
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://eevt4eldn0.execute-api.ap-northeast-1.amazonaws.com/emmalynn",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://6vvtewoq75ftnlh3wcrnny3mqq.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-northeast-1:539b873a-006a-4772-8d80-0bf8b8ac8a99",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_JA3Ybjcfi",
    "aws_user_pools_web_client_id": "24pp71adg82epvjelqb6qlsq61",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tasktimemngapp-storage-67d2296b54236-emmalynn",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
